import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ProjectStatusSchema } from '../project.models.ts'
import { ProjectIdSchema } from '../unique-id.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

// This is a subset of the project statuses since not all status changes require an activity
export const ProjectStatusChangedActivityStatusSchema =
  ProjectStatusSchema.extract([
    'complete',
    'post_production_complete',
    'pre_production_complete',
    'processing_final_files',
    'production',
  ])

export type ProjectStatusChangedActivityStatus = ZodInfer<
  typeof ProjectStatusChangedActivityStatusSchema
>

const ProjectStatusChangedActivityDataSchema = z.object({
  projectId: ProjectIdSchema,
  ...ActivityLinkTargets('project'),
})

// Deprecated statuses that are still may appear in activity data
export const DeprecatedProjectStatusChangedActivityStatusSchema = z.enum([
  'submitted',
  'matched',
])

export type DeprecatedProjectStatusChangedActivityStatus = ZodInfer<
  typeof DeprecatedProjectStatusChangedActivityStatusSchema
>

export const ProjectStatusChangedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'project_status_changed',
    // Right now the data schemas are the same for all statuses, but
    // in the future we may have different shapes for different statuses
    z.discriminatedUnion('status', [
      ProjectStatusChangedActivityDataSchema.extend({
        // Union with submitted and matched statuses to support legacy activity data
        status: z.enum([
          ...ProjectStatusChangedActivityStatusSchema.options,
          ...DeprecatedProjectStatusChangedActivityStatusSchema.options,
        ]),
      }),
    ])
  )
